export default __webpack_public_path__ + "static/media/dex.df8fc234.svg";